import {
	ChangeDetectionStrategy,
	Component,
	Directive,
	ElementRef,
	inject,
	Injectable,
	Injector,
	Input,
	OnInit,
	Renderer2,
	ViewEncapsulation
} from '@angular/core';
import {SelfListFetcherBase} from '@im-ng/api2';
import {InlineInput, InlineInputPreset} from '@im-ng/form';
import {HttpRequester} from '@js-dot/api/http';
import {DotComponentService} from '@ng-dot/core';
import {DotToastSeries, DotToastService} from '@ng-dot/ui/toast';
import {BehaviorSubject} from 'rxjs';
import {MainListComponentBase} from './main-list-component-base';

@Component({
	selector: 'im-inline-editor-style',
	template: ``,
	styleUrls: ['im-inline-editor.scss'],
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class InlineEditorStyleComponent {
}

@Injectable({
	providedIn: 'root'
})
export class InlineEditorStyleService {
	constructor(_component: DotComponentService) {
		_component.append(InlineEditorStyleComponent).destroy();
	}
}

@Directive()
export abstract class InlineEditorComponentBase<TPreset extends string, TModel> extends MainListComponentBase
	implements OnInit {

	@Input() set preset(name: TPreset) {
		const {feature, targets} = this._presets[name];
		this.feature             = feature;
		this._setDefinedHeading(feature);

		this.targets = targets;
	}

	targets: InlineInput<any>[];
	changed$ = new BehaviorSubject(false);

	protected _toast: DotToastSeries;
	protected _service: { $updates: HttpRequester };
	protected _fetcher: SelfListFetcherBase;
	protected _presets: InlineInputPreset<TPreset, any>;
	protected _changes: Record<any, Partial<TModel>> = {};

	constructor(
		presets: InlineInputPreset<any, any>,
		fetcher: SelfListFetcherBase,
		service: { $updates: HttpRequester }
	) {
		super();
		const injector = inject(Injector);
		injector.get(InlineEditorStyleService);
		const renderer = injector.get(Renderer2);
		renderer.addClass(injector.get(ElementRef).nativeElement, 'im-inline-editor');
		this._toast   = injector.get(DotToastService).series(this.constructor.name);
		this._presets = presets;
		this._fetcher = fetcher;
		this._service = service;
	}

	change(event: InputEvent, item: Partial<TModel>) {
		const target = event.target as HTMLInputElement;

		let value: any = target.value;

		switch (target.type) {
			case 'checkbox':
				value = target.checked;
		}

		const {changed$, _changes} = this;

		const primaryKey = 'seq';
		const key        = item[primaryKey];

		const change        = (_changes[key] || (_changes[key] = {[primaryKey]: key} as any));
		change[target.name] = value;

		if (!changed$.value) {
			changed$.next(true);
		}
	}

	submit() {
		const {_toast, _changes, _fetcher} = this;

		_toast.low('한번에 저장 중이에요.');
		const body = Object.values(this._changes);
		this._service.$updates.request(null, body)
			.subscribe({
				next: response => {
					console.warn(response);
					_toast.low('한번에 저장 했어요.');
					this._changes = {};
					this.changed$.next(false);
					_fetcher.reload();
				},
				error: reason => {
					_toast.low('한번에 저장하지 못했어요.');
					_fetcher.reload();
				}
			});
	}
}
